import { SessionAction, SessionActionType, OrderData } from 'app/session/actions'
import clone from 'lodash/cloneDeep'
import { API_Authenticate, API_GetConfig, API_Geti18n, API_GetMerchantParams } from 'app/api'


//Types.

export type SessionState = {
  initialized: boolean
  config?: API_GetConfig
  i18n?: API_Geti18n
  merchantParams?: API_GetMerchantParams
  auth: API_Authenticate | null
  order: OrderData | null
}


//State.

const initialState: SessionState = {
  initialized: false,
  auth: null,
  order: null,
}


//Reducers.

export default function sessionReducer(state: SessionState = initialState, action: SessionAction): SessionState {
  switch (action.type) {
    case SessionActionType.Initialize: {
      if (action.data == null) console.error('No initialization data received')
      return {
        ...state,
        initialized: action.data
      }
    }

    case SessionActionType.UpdateConfig: {
      if (action.data == null) console.error('No config data received')
      return {
        ...state,
        config: action.data
      }
    }

    case SessionActionType.Updatei18n: {
      if (action.data == null) console.error('No i18n data received')
      return {
        ...state,
        i18n: action.data
      }
    }

    case SessionActionType.UpdateMerchantParams: {
      if (action.data == null) console.error('No merchant params received')
      return {
        ...state,
        merchantParams: action.data
      }
    }

    case SessionActionType.Authenticate: {
      if (action.data == null) console.error('No user data received')
      return {
        ...state,
        auth: action.data
      }
    }

    case SessionActionType.Logout: {
      Object.assign(state, clone(initialState))
      return state
    }

    case SessionActionType.UpdateOrder: {
      if (action.data == null) console.error('No order data received')
      return {
        ...state,
        order: action.data
      }
    }

    default: {
      return state
    }
  }
}
